import { useState } from "react";
import apiEndPoint from "../../services/apiService/apiEndPoints";
import { postApi } from "../../services/apiService/fetchMethod";
import { message } from "antd";
import LoaderCircle from "../../commonComponents/loader/LoaderCircle";

function Contact() {
  const [fname, setFName] = useState("");
  const [lname, setLName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [companySize, setCompanySize] = useState("");
  const [messageVal, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const url = apiEndPoint().CONTACT_US;
    const { status, data } = await postApi({
      url,
      params: {
        name: fname + " " + lname,
        email,
        phone: number,
        companyName,
        companySize,
        message: messageVal,
      },
    });
    console.log(status, data);
    if (status === 200) {
      message.success(data.message);
      setCompanyName("");
      setLName("");
      setFName("");
      setNumber("");
      setCompanySize("");
      setEmail("");
      setMessage("");
    } else {
      message.error(data.message);
    }
    setLoading(false);
  };
  return (
    <section id="contact" className="contact">
      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Contact</h2>
          <p>Contact Us</p>
        </header>
        <div className="row gy-4 d-flex justify-content-center align-items-center">
          {/* <div className="col-lg-6">
            <div className="row gy-4">
              <div className="col-md-6">
                <div className="info-box" style={{ height: "370px" }}>
                  <i className="bi bi-geo-alt"></i>
                  <h3>Address</h3>
                  <p>
                    Assert AI
                    <br />
                    303, A-Wing, Kanakia Zillion, LBS
                    Marg, Kurla West,
                    <br />
                    Mumbai - 400070
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="info-box" style={{ height: "370px" }}>
                  <i className="bi bi-telephone"></i>
                  <h3>Let's Talk</h3>
                  <p>
                    Phone: +91-8657-009634,
                    <br />
                    Landline: +91-2246-001924
                    <br />
                  </p>
                  <p>
                    Email: info@assertai.com
                    <br />
                  </p>
                </div>
              </div>
            </div>
          </div> */}

          <div className="col-lg-6">
            <form onSubmit={handleSubmit} className="php-email-form">
              <div className="row gy-4">
                <div className="col-md-6">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="First Name"
                    value={fname}
                    onChange={(e) => setFName(e.target.value)}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Last Name"
                    value={lname}
                    onChange={(e) => setLName(e.target.value)}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Company Name"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Mobile Number"
                    value={number}
                    onChange={(e) => setNumber(e.target.value)}
                  />
                </div>
                <div className="col-md-6 ">
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Work Email"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <select
                    className="form-control"
                    placeholder="Company Size"
                    value={companySize}
                    onChange={(e) => setCompanySize(e.target.value)}
                  >
                    <option value="0">Select Company Size</option>
                    <option value="10-250">10-250</option>
                    <option value="250-1000">250-1000</option>
                    <option value="1000-5000">1000-5000</option>
                    <option value="5000+">5000+</option>
                  </select>
                </div>
                <div className="col-md-12">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Please Elaborate Your Requirement"
                    value={messageVal}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                  />
                </div>

                <div className=" d-flex justify-content-center align-items-center">
                  <button
                    type="submit"
                    style={{ width: "180px" }}
                    className=" d-flex justify-content-center align-items-center"
                  >
                    {loading ? <LoaderCircle size={20} /> : "Send Message"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
